import React, { useState, useEffect, useCallback, useRef, memo } from "react";
import useStyles from "./style";
import { useTheme } from '@mui/material/styles';
import {
  Slide,
  Grid
} from "@mui/material";
import _ from "lodash";
import dayjs from "dayjs";
import customParseFormat from "dayjs/plugin/customParseFormat";
import utc from "dayjs/plugin/utc";
import { showLoader, hideLoader } from "Redux/Loader/actions";
import { showSnackbar } from "Redux/SnackBar/actions";
import { useDispatch } from "react-redux";
import {
  APIProvider,
  Map,
  useMap,
  useMapsLibrary,
  AdvancedMarker,
  Pin,
  InfoWindow
} from '@vis.gl/react-google-maps';

// Components 

import Dispatcherhead from "./Dispatcherheader";
import DriverList from "./Driverslist"
import BookingForm from "./Bookingform"
import PackageBookingForm from "./PackageBookingform"

//Services
import DispatcherApi from "Services/Dispatcher";
import settingsApi from "Services/Settings";
import { setNewtimezone, setSystemlatitude, setSystemlongitude } from "Redux/TimeZone/actions";
import { API_ENDPOINTS } from "../../Constants";
import { useNavigate } from 'react-router-dom';
import { useSelector } from "react-redux";
dayjs.extend(customParseFormat);
dayjs.extend(utc);

const Dispatcherpanel = () => {

  const timezone = useSelector((state) => {
    const selectedTimezone = state?.timezone?.timezone || 'America/Anchorage';
    return selectedTimezone === "Asia/Coimbatore" ? "Asia/Kolkata" : selectedTimezone;
  });
  const systemlatitude = useSelector((state) => Number(state?.timezone?.latitude) || 11.127123);
  const systemlongitude = useSelector((state) => Number(state?.timezone?.longitude) || 78.656891);
  console.log('systemlatitude--->', useSelector((state) => state));
  const classes = useStyles();
  const dispatch = useDispatch();
  const [services, setservices] = useState([]);
  const [allDrivers, setalldrivers] = useState([]);
  const [selectedservice, setSelectedservice] = useState('');
  const [selectedstatus, setSelectedstatus] = useState('ALL');
  const [availabledrivers, setavailabledrivers] = useState([]);
  const [selectedDriver, setSelectedDriver] = useState([]);
  const userType = useSelector(
    (state) => state?.AuthReducer?.userType || ""
  );
  const subcmpnyName = useSelector(
    (state) => state?.AuthReducer?.subCmpny || ""
  );
  const demoaccount_id = useSelector(
    (state) => state?.AuthReducer?.demoaccount_id || localStorage.getItem("demoaccount_id") || ""
  );
  const [mapZoom, setMapZoom] = useState(10);
  const userid = useSelector(
    (state) => state?.AuthReducer?.userId || ""
  );
  const [open, setOpen] = useState(true);
  const [openbooking, setOpenbooking] = useState(true);
  const [openPackageBooking, setOpenPackageBooking] = useState(false);
  // Reset callbacks exposed by each child form
  const resetBookingFormRef = useRef(null);
  const resetPackageFormRef = useRef(null);
  const [infoWindowData, setInfoWindowData] = useState(null);

  //map things 
  const [origin, setOrigin] = useState("");
  const [destination, setDestination] = useState("");
  const [mapCenter, setMapCenter] = useState({ lat: systemlatitude, lng: systemlongitude });
  const map = useMap();
  const mapRef = useRef(null);
  const navigate = useNavigate();

  //console.log('mapCenter--->',mapCenter);

  const getBusinessSettingsData = useCallback(() => {
    const params = {};
    if (demoaccount_id && demoaccount_id.trim() !== "") {
      params.demoaccount_id = demoaccount_id.trim();
    }
    settingsApi.getBusinessSettings(params).then((res) => {
      if (res?.data?.status === true && res?.data?.data) {
        const bsData = res.data.data;
        const lat = parseFloat(bsData?.latitude);
        const lng = parseFloat(bsData?.longitude);
        const zoom = parseInt(bsData?.mapZoomLevel, 10);

        if (bsData?.timeZone) {
          dispatch(setNewtimezone(bsData.timeZone));
        }

        if (!isNaN(lat) && !isNaN(lng) && lat !== 0 && lng !== 0) {
          dispatch(setSystemlatitude(lat));
          dispatch(setSystemlongitude(lng));
          setMapCenter({ lat, lng });
          if (!isNaN(zoom) && zoom > 0) {
            setMapZoom(zoom);
          }
        }
      }
    }).catch((err) => {
      console.error("Error fetching business settings for dispatcher map:", err);
    });
  }, [demoaccount_id, dispatch]);

  useEffect(() => {
    getBusinessSettingsData();
  }, [getBusinessSettingsData]);

  const getservicesanddrivers = useCallback(() => {
    dispatch(showLoader("Loading please wait..."));
    const onSuccess = (res) => {
      dispatch(hideLoader());
      //console.log("fetched user request data--->",res?.data);
      if (res?.data?.status === true) {
        //console.log("fetched active service data--->",res?.data?.data?.serviceTypeDetails)
        // console.log("fetched available drivers data--->",res?.data?.data?.driverInfoDetails)
        setservices(res?.data?.data?.serviceTypeDetails);
        setalldrivers(res?.data?.data?.driverInfoDetails);

        if (res?.data?.data?.businessSettings) {
          const bsData = res.data.data.businessSettings;
          const lat = parseFloat(bsData?.latitude);
          const lng = parseFloat(bsData?.longitude);
          const zoom = parseInt(bsData?.mapZoomLevel, 10);

          if (bsData?.timeZone) {
            dispatch(setNewtimezone(bsData.timeZone));
          }
          if (!isNaN(lat) && !isNaN(lng) && lat !== 0 && lng !== 0) {
            dispatch(setSystemlatitude(lat));
            dispatch(setSystemlongitude(lng));
            setMapCenter({ lat, lng });
            if (!isNaN(zoom) && zoom > 0) {
              setMapZoom(zoom);
            }
          }
        }
      } else {
        setalldrivers([]);
      }
    };
    const onFailure = (err) => {
      dispatch(hideLoader());
      dispatch(
        showSnackbar({
          message: err?.response?.data?.message || "Failed to fetch data",
          autoHideDuration: 3000,
          anchorOrigin: {
            vertical: "top",
            horizontal: "right",
          },
          variant: "error",
        })
      );
      //console.log("Get member / partner details Api", err);
    };
    const params = {};
    if (demoaccount_id) {
      params.demoaccount_id = demoaccount_id;
    }
    DispatcherApi.getdriversandservices(params).then(onSuccess, onFailure);
  }, [demoaccount_id, dispatch]);
  // console.log(allDrivers);
  useEffect(() => {
    setMapCenter({ lat: systemlatitude, lng: systemlongitude });
    getservicesanddrivers();

  }, [systemlatitude, systemlongitude, getservicesanddrivers]);

  // Set selected services from header

  useEffect(() => {
    if (selectedservice) {
      //console.log('Updated Selected Service ID:', selectedservice); 
      getselectedservicedrivers(selectedservice); // Trigger function when selectedservice changes
    }
  }, [selectedservice]);


  const getselectedservicedrivers = useCallback((selectedservice) => {
    dispatch(showLoader("Loading please wait..."));

    //console.log('id--->',selectedservice);
    const onSuccess = (res) => {
      dispatch(hideLoader());
      //console.log("fetched user request data--->",res?.data);
      if (res?.data?.status === true && res?.data?.data?.length > 0) {
        setavailabledrivers(res?.data?.data);
      } else {
        setavailabledrivers([{ no_drivers: "No drivers found for this service" }]);
      }
    };
    const onFailure = (err) => {
      dispatch(hideLoader());
      dispatch(
        showSnackbar({
          message: err?.response?.data?.message || "Failed to fetch data",
          autoHideDuration: 3000,
          anchorOrigin: {
            vertical: "top",
            horizontal: "right",
          },
          variant: "error",
        })
      );
      //console.log("Get member / partner details Api", err);
    };
    const params = { id: selectedservice };
    if (demoaccount_id) {
      params.demoaccount_id = demoaccount_id;
    }
    DispatcherApi.getselectedservicedrivers(params).then(onSuccess, onFailure);
  }, [demoaccount_id]);


  // set selected ride status from header

  const getselectedridestatus = useCallback((statusToFetch) => {
    const status = statusToFetch !== undefined ? statusToFetch : selectedstatus;
    dispatch(showLoader("Loading please wait..."));
    let data = {
      rideStatus: status
    };
    if (demoaccount_id) {
      data.demoaccount_id = demoaccount_id;
    }
    const onSuccess = (res) => {
      dispatch(hideLoader());
      if (res?.data?.status === true && res?.data?.data?.length > 0) {
        setavailabledrivers(res?.data?.data);
      } else {
        setavailabledrivers([{ no_drivers: "No drivers found for this status" }]);
      }
    };
    const onFailure = (err) => {
      dispatch(hideLoader());
      dispatch(
        showSnackbar({
          message: err?.response?.data?.message || "Failed to fetch data",
          autoHideDuration: 3000,
          anchorOrigin: {
            vertical: "top",
            horizontal: "right",
          },
          variant: "error",
        })
      );
    };
    DispatcherApi.getselectedridestatus(data).then(onSuccess, onFailure);
  }, [demoaccount_id, selectedstatus, dispatch]);

  const handleStatusChange = useCallback((status) => {
    setSelectedstatus(status);
    setSelectedDriver(null);
    setSelectedservice('');
    getselectedridestatus(status);
  }, [getselectedridestatus]);

  // click the marker to show the driver details

  const handleMarkerClick = useCallback((row) => {
    setInfoWindowData(row);
  }, []);

  // Dynamic recenter component for the map
  const MapRecenter = memo(({ center, zoom }) => {
    const map = useMap();
    useEffect(() => {
      if (map && center && !isNaN(center.lat) && !isNaN(center.lng)) {
        map.panTo(center);
        if (zoom && !isNaN(zoom)) {
          map.setZoom(zoom);
        }
      }
    }, [map, center?.lat, center?.lng, zoom]);
    return null;
  });

  const libraries = ["places", "drawing", 'routes'];

  // Direction rendering component 

  const Directions = memo(({ origin, destination }) => {
    const map = useMap();
    const routesLibrary = useMapsLibrary("routes");
    const [directionsRenderer, setDirectionsRenderer] = useState(null);

    useEffect(() => {
      if (!origin || !destination) return;

      if (!directionsRenderer) {
        const newDirectionsRenderer = new routesLibrary.DirectionsRenderer({ map });
        setDirectionsRenderer(newDirectionsRenderer);
      }

      const directionsService = new routesLibrary.DirectionsService();

      directionsService.route({
        origin,
        destination,
        travelMode: "DRIVING",
      })
        .then((response) => {
          directionsRenderer?.setDirections(response);
        })
        .catch((error) => console.error("Error fetching directions:", error));

      return () => {
        directionsRenderer?.setMap(null);
      };
    }, [origin, destination, map, routesLibrary, directionsRenderer]);

    return null;
  });

  const currentDrivers = (availabledrivers && availabledrivers.length > 0 && !availabledrivers[0]?.no_drivers)
    ? availabledrivers
    : (!availabledrivers || availabledrivers.length === 0 ? allDrivers : []);

  const driversToShow = selectedDriver && Object.keys(selectedDriver).length > 0
    ? [selectedDriver]
    : currentDrivers;

  return (
    <>

      <Grid container className={classes.mapcontainer} >
        <Grid item xs={12} >

          <APIProvider
            apiKey={API_ENDPOINTS.GMAP_API} // Use your actual API key
            libraries={libraries}
          >
            <React.Fragment >
              <Map
                style={{
                  width: "111vw",
                  height: "111vh",
                }}
                defaultCenter={mapCenter}
                defaultZoom={mapZoom}
                gestureHandling={"greedy"}
                mapId={"40e581fce79a8421a2f62ee2"}
              >
                <MapRecenter center={mapCenter} zoom={mapZoom} />
                {/* Header of the dispatcher panel */}

                <Dispatcherhead
                  userType={userType}
                  selectedstatus={selectedstatus}
                  setSelectedstatus={handleStatusChange}
                  setSelectedservice={setSelectedservice}
                  selectedservice={selectedservice} />

                {/* left side driver listing */}

                <DriverList
                  userType={userType}
                  subcmpnyName={subcmpnyName}
                  allDrivers={allDrivers}
                  availabledrivers={availabledrivers}
                  setMapCenter={setMapCenter}
                  setSelectedDriver={setSelectedDriver}
                  selectedstatus={selectedstatus}
                />

                {/* booking form */}

                <BookingForm
                  userType={userType}
                  subcmpnyName={subcmpnyName}
                  demoaccount_id={demoaccount_id}
                  setOpenbooking={setOpenbooking}
                  setOpen={setOpen}
                  openbooking={openbooking}
                  setOrigin={setOrigin}
                  setDestination={setDestination}
                  origin={origin} destination={destination}
                  setMapCenter={setMapCenter}
                  services={services}
                  timezone={timezone}
                  registerReset={(fn) => { resetBookingFormRef.current = fn; }}
                  onOpen={() => { if (resetPackageFormRef.current) resetPackageFormRef.current(); }}
                />

                {/* Package and Logistics booking form */}
                <PackageBookingForm
                  openPackageBooking={openPackageBooking}
                  setOpenPackageBooking={setOpenPackageBooking}
                  userType={userType}
                  subcmpnyName={subcmpnyName}
                  demoaccount_id={demoaccount_id}
                  setOrigin={setOrigin}
                  setDestination={setDestination}
                  origin={origin}
                  destination={destination}
                  setMapCenter={setMapCenter}
                  services={services}
                  timezone={timezone}
                  registerReset={(fn) => { resetPackageFormRef.current = fn; }}
                  onOpen={() => { if (resetBookingFormRef.current) resetBookingFormRef.current(); }}
                />

                {/* direction rendering */}

                <Directions origin={origin} destination={destination} />

                {/* Customized Car Marker */}

                {driversToShow.map((driver) => (
                  <AdvancedMarker
                    position={{
                      lat: Number(driver?.driver_ride_details?.latitude),
                      lng: Number(driver?.driver_ride_details?.longitude)
                    }}
                    title="Driver Location"
                    onClick={() => handleMarkerClick(driver)}>
                    <Pin
                      background={
                        driver?.driver_ride_details?.rideStatus == 'ACTIVE' ? '#30e356' :
                          driver?.driver_ride_details?.rideStatus == 'OFFLINE' ? '#f44336' : '#0472e2'}
                      borderColor={
                        driver?.driver_ride_details?.rideStatus == 'ACTIVE' ? '#30e356' :
                          driver?.driver_ride_details?.rideStatus == 'OFFLINE' ? '#f44336' : '#0472e2'
                      }
                      glyphColor={'#fffff'}
                    >
                      <img
                        src={
                          driver?.driver_ride_details?.rideStatus == 'ACTIVE' ?
                            '/assets/images/DispatcherIcons/activecar.png' :
                            driver?.driver_ride_details?.rideStatus == 'OFFLINE' ?
                              '/assets/images/DispatcherIcons/offlinecar.png' :
                              '/assets/images/DispatcherIcons/activecar.png'
                        }
                        alt="Driver Car"
                        style={{
                          width: "40px",
                          height: "40px",
                          borderRadius: "12px"
                        }}
                      />
                    </Pin>
                  </AdvancedMarker>
                ))}

                {infoWindowData && (
                  <InfoWindow
                    position={{
                      lat: Number(infoWindowData?.driver_ride_details?.latitude),
                      lng: Number(infoWindowData?.driver_ride_details?.longitude)
                    }}
                    onCloseClick={() => setInfoWindowData(null)}
                  >
                    <div style={{ padding: '10px' }}>
                      <h3>Driver Details</h3>
                      <p><b>Name:</b> {infoWindowData?.firstName + " " + infoWindowData?.lastName}</p>
                      <p><b>Car:</b> {infoWindowData?.driver_ride_details?.service_details?.serviceName}</p>
                      <p><b>Address:</b> {infoWindowData?.driver_ride_details?.address}</p>
                    </div>
                  </InfoWindow>
                )}

              </Map>
            </React.Fragment>
          </APIProvider>

        </Grid>
      </Grid>
    </>
  );
};



export default Dispatcherpanel;
